'use strict';

function LoanApplicationStatus() {
  var _this2 = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._$classes = {
    nextBtn: '.js--next',
    progressBarEl: '.js--loan-application-progress-bar',
    disclaimer: '.js--legal-disclaimer',
    continue: '.js--loan-application-continue'
  };

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    if (this._loanApplications.length === 0) {
      return;
    }

    this._stepsArray = [{
      visible: true,
      percentage: 0,
      title: 'Apply'
    }, {
      visible: false,
      percentage: 15,
      title: 'pending'
    }, {
      visible: false,
      percentage: 35,
      title: 'outstanding'
    }, {
      visible: true,
      percentage: 50,
      title: 'In review'
    }, {
      visible: true,
      percentage: 100,
      title: 'Sign'
    }];

    this._$node = $(this.node);
    this._loanApplicationModel = this._loanApplications[0].getModelPath();
    this._loanApplicationStatus = this._loanApplications[0].getStatus();
    this._termsReference = this._loanApplications[0].getTermsReference();
    this._aprReference = this._loanApplications[0].getAprReference();
    this._statusReference = this._loanApplications[0].getStatusReference();
    this._relinkReference = this._loanApplications[0].getRelinkReference();
    this._currentStep = this._loanApplications[0].getCurrentStep();

    this._$continueBtn = this._$node.find(this._$classes.continue);
    this._$progressBarEl = this._$node.find(this._$classes.progressBarEl);

    this._setupComputedVariables();
    this._setupEventHandlers();

    this._pushAnalytics();
    // Decline screen is different from the progress bar status view
    if (this._loanApplicationStatus !== 'declined') {
      this._setupProgressBar();
    }

    if (this._loanApplicationStatus === 'in_progress') {
      mogo.ready(function () {
        _this._createDisclaimer();
      });
    }

    // LiveChat is only on certain blocks
    if (this._loanApplicationStatus !== 'in_progress') {
      this._setupLivechat();
    }
  };

  this._isOfferPaused = function () {
    return (
      // if there's an active offer and the active offer is paused.
      !!(_this2._activeOffer.getOfferData() && _this2._activeOffer.isOfferPaused())
    );
  };

  this._pushAnalytics = function () {
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._setupProgressBar = function () {
    var _this3 = this;

    this._$progressBarEl.mogo().create('ProgressBar', {
      steps: this._stepsArray
    });

    mogo.ready(function () {
      _this3._setupStatusScreen(_this3._loanApplicationStatus);
    });
  };

  this._createDisclaimer = function () {
    var legal = $('.js--legal-disclaimer', this._$node);

    legal.mogo().create('LegalDisclaimer', {
      legal: $('[data-legal]', this._$node),
      presenter: this.presenter
    });
  };

  this._setupEventHandlers = function () {
    var _this4 = this;

    this._$continueBtn.on('click', function () {
      if (_this4._currentStep) {
        return _this4.history.goToUrl(_this4._currentStep);
      }
      // Fail safe;
      return _this4.history.goToUrl(_this4.paths.loans.application_flow_start);
    });
  };

  // Function copied from else where;
  this._setupLivechat = function () {
    // scope variables because elements might not be visible yet
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");
    this._$liveChat = $('.js--live-chat');
    this._$chatBtn = $('.js--chat-with-us');

    // Prevents LiveChat from creating another component IE LiveChat_1
    // Behavior: Hide Chatbubble unless they click a chat bubble CTA
    if (this._$chatBtn.length > 0 && this._liveChatComponent.length === 0) {
      this._$liveChat.mogo().create('LiveChat', {
        presenter: this.presenter
      });
    } else if (this._liveChatComponent.length) {
      this._liveChatComponent.mogo().hideChatIfNotEngaged();
    }

    this._$chatBtn.on('click', function (e) {
      e.preventDefault();
      if (window.LC_API && window.LC_API.open_chat_window) window.LC_API.open_chat_window();
    });
  };

  this._setupComputedVariables = function () {
    var _this5 = this;

    // Application Values
    // Decline does not show offer amount
    if (this._loanApplicationStatus !== 'declined') {
      this.presenter.addComputedVariable('loan-amount', [this._loanApplicationModel + '.amount'], function (val) {
        // Get selectored amount otherwise, show pre approved amount
        if (_this5._loanApplications[0].getLoanApplicationAmount()) {
          return _this5._loanApplications[0].getLoanApplicationAmount();
        }
        return _this5._activeOffer.getOfferAmount() || _this5._expiredOffer.getOfferAmount();
      });
    }

    this.presenter.addComputedVariable('loan_amount_term', [this._termsReference], function (term) {
      return _this5._loanApplications[0].getTermsInPreferredUnits() + ' ';
    });

    this.presenter.addComputedVariable('status', [this._statusReference], function (val) {
      return _this5._isOfferPaused() ? 'hold' : _this5._loanApplicationStatus;
    });

    this.presenter.addComputedVariable('relink_reason', [this._relinkReference], function (val) {
      return _this5._loanApplications[0].getRelinkReason();
    });

    this.presenter.addComputedVariable('loan_amount_apr', [this._aprReference], function (apr) {
      if (apr) {
        return apr;
      }
      return '';
    });
  };

  this._setupStatusScreen = function (status) {
    var index = 0;

    // No new status is introduced for when user has hard consent
    if (this._loanApplications[0].hasHardConsent() && status === 'in_progress') {
      index = 3;
    } else {
      switch (status) {
        case 'in_progress':
          index = 2;
          break;
        case 'bank_service_in_progress':
        case 'outstanding_docs':
          index = 3;
          break;
        case 'initial_review':
        case 'additional_review':
        case 'additional_conditions':
        case 'relink':
        case 'engage':
          index = 4;
          break;
        case 'agreements_ready':
        case 'agreements_expired':
        case 'agreements_signed':
        case 'originated':
          index = 5;
          break;
        default:
          index = 1;
          break;
      }
    }

    this._$progressBarEl.mogo().setCurrentStep(index);
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('loan-amount');
    this.presenter.removeComputedVariable('loan_amount_term');
    this.presenter.removeComputedVariable('loan_amount_apr');
    this.presenter.removeComputedVariable('status');
    this.presenter.removeComputedVariable('relink_reason');

    this._super();
  };
}